import { ProductTags } from '@app/constants/product-tags.constants';
import { Price } from '@app/entities/price';
import { RequestSettingsBase } from '@app/entities/request-settings';
import { PaxType } from '@app/modules/booking/entities/pax-type';
import { SorterTypes } from '@shared/filters/entities/sorter-options';

export type ActivitiesSearchResultsPayload = Readonly<{
  SessionToken: string;
  IsOnlyResults: boolean;
  IsExtraGroup: boolean;
  Search: ActivitiesSearchPayload;
  Results: ActivitiesResultsPayload;
}>;

export type ActivitiesSearchPayload = Readonly<{
  RequestSettings: RequestSettingsBase;
  CurrencyCode: string;
  CityCodeType: string;
  DateTo: Date;
  DateFrom: Date;
  MaxResults?: number;
  ContextSearchType?: string;
  CityCode?: string;
  ActivityId?: string;
  SearchOnlyRequestedActivityId?: boolean;
}>;

export type ActivitiesResultsPayload = Readonly<{
  SearchId: string;
  ActivityDates: string[];
  Categories: string[];
  ActivityType: string[];
  ActivityName: string;
  PriceFrom: number;
  IncludeProducts: boolean;
  PriceTo: number;
  ResultCountLowerBound: number;
  ResultCountUpperBound: number;
  Tags: string[];
  OrderCriteria: SorterTypes;
  OrderDesc: boolean;
  MaxOptionsResults: number;
  SplitHtml: boolean;
}>

export type ActivitiesResultsResponse = Readonly<{
  SearchId: string;
  ExtraOptions: ActivitiesResultsExtraOption[];
  Results: number;
}>

export type ActivitiesResultsExtraOption = Readonly<{
  ClassTag?: ProductTags;
  ExtraInfo: ActivitiesResultsExtraOptionInfo;
  OptionId: number;
  PreferenceOrder: number;
  ProductOptions: ProductOption[];
  ProductReference: string;
  PromotionalText?: string;
  Provider: string;
  RequiredExecuteDetails: boolean;
  SellPriceFrom: Price;
  Tag: string;
}>

export type ActivitiesResultsExtraOptionInfo = Readonly<{
  Code: string;
  Name: string;
  City: string;
  Descriptions: ActivitiesResultsExtraOptionDescription;
  Images: ActivitiesResultsExtraOptionImages[];
}>

export type ActivitiesResultsExtraOptionDescription = Readonly<{
  Description: string;
  HightDescription: string;
}>

export type ActivitiesResultsExtraOptionImages = Readonly<{
  ImageUrl: string;
}>

export type ProductOption = Readonly<{
  ActivityType: string;
  CancellationPolicies: string;
  Categories?: Categories[];
  FareDescription?: string;
  Fares: Fares[];
  Images?: ActivitiesResultsExtraOptionImages[];
  ProductCode: string;
  ProductDescription?: string;
  ProductName: string;
  RequireAllPaxInfo: boolean;
  TextFare?: string;
  TravelExtraConditions?: string;
}>

export enum PriceType {
  PerService = 'PerService',
  PerPerson = 'PerPerson',
}

export enum AtttributeCodes {
  PaxTypes = 'PaxType',
  Times = 'Times',
  Categories = 'Category'
}

export type Fares = Readonly<{
  Attributes: FareAttributes[];
  AvailableDates?: string[];
  FareId: number;
  MaxAge?: number;
  MaxPax?: number;
  MinAge?: number;
  MinPax?: number;
  PaxName?: string;
  PaxType: PaxType;
  PriceType: PriceType;
  Quantity: number;
  SellPriceAmount: Price;
}>

export type FareAttributes = Readonly<{
  Code: AtttributeCodes;
  Description: string;
  Value: string;
}>

export type Categories = Readonly<{
  Id: number;
  Name: string;
}>

export type ActivitiesDetailPayload = Readonly<{
  SearchId: string;
  SessionToken: string;
  OptionId: number;
}>;

export type ActivitiesDetailResponse = Readonly<{
  ExtraOption: ActivitiesResultsExtraOption;
}>;
